import { render, staticRenderFns } from "./employees-settings-dynamic-fields.vue?vue&type=template&id=38910b82&"
import script from "./employees-settings-dynamic-fields.vue?vue&type=script&lang=js&"
export * from "./employees-settings-dynamic-fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports